import { DropdownMenu as RadMenu } from 'radix-ui'
import { cn } from '@/utlis/cn'
import { useContext } from 'react'
import { PortalContext } from './PortalContext'
import '@/components/dropdown-animation.css'

export type SimpleMenuItem = {
    label: React.ReactNode
    onClick?: () => void
    className?: string
    closeOnSelect?: boolean
    asChild?: boolean
}

type SimpleMenuProps = {
    className?: string
    children?: React.ReactNode
    items: SimpleMenuItem[]
    onOpenChange?: (open: boolean) => void
    triggerAsChild?: boolean
}

/// A very simple menu popover intended for menus with homogenous button items
export function SimpleMenu(props: SimpleMenuProps) {
    const portalContainer = useContext(PortalContext)

    return (
        <RadMenu.Root onOpenChange={(open) => props.onOpenChange?.(open)} modal={false}>
            <RadMenu.Trigger asChild={props.triggerAsChild ?? true}>{props.children}</RadMenu.Trigger>

            <RadMenu.Portal container={portalContainer}>
                <RadMenu.Content
                    collisionPadding={15}
                    sideOffset={5}
                    className={cn(
                        'dropdown-menu-content z-30 py-4 bg-muse-menu rounded-[16px] shadow-glow min-w-[200px] max-h-[50vh] overflow-y-auto',
                        props.className
                    )}
                >
                    {props.items.map((item, i) => (
                        <div className={item.className} key={i}>
                            <RadMenu.Item
                                className={cn(
                                    'cursor-pointer w-full px-4 py-2 hover:bg-white/10 transition-colors duration-250 outline-none focus-visible:bg-white/10'
                                )}
                                onClick={(ev) => {
                                    if (!(item.closeOnSelect ?? true)) {
                                        ev.preventDefault()
                                    }
                                    item.onClick?.()
                                }}
                                asChild={item.asChild}
                            >
                                {item.label}
                            </RadMenu.Item>
                        </div>
                    ))}
                </RadMenu.Content>
            </RadMenu.Portal>
        </RadMenu.Root>
    )
}
